import MuiCircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export const CircularProgress = ({ color = 'primary', size = 'sm', ...rest }: CircularProgressProps) => {
  return <MuiCircularProgress color={color} size={size} {...rest} />;
};

export default CircularProgress;
